import { defineComponent, h, defineAsyncComponent } from 'vue';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import TranslationContainer from '../TranslationContainer.jsx';
import Pg2Row from './Pg2Row.jsx';

const PropertyGrid2 = defineAsyncComponent(() => import('../form/PropertyGrid2.jsx'));

export default defineComponent({
    name: 'form2-hsm-statement-schema',
    components: {
        PropertyGrid2,
        TranslationContainer,
        Pg2Row,
    },
    data: function () {
        return {
            condition_expn: null,
            control_schema: null,
        };
    },
    created() {
        this.watcher$ = this.$watch('cmodel.StatementName', function () {
            this.Refresh();
        });
    },
    unmounted() {
        if (this.watcher$) this.watcher$();
    },
    mounted() {
        this.Refresh();
    },
    computed: {
        ...utils.forms.computed,
    },
    methods: {
        ...methods,
        Refresh() {
            const c = this.FindDesignerChildHsmStatement(this.cmodel.StatementName);
            if (c) {
                this.control_schema = {
                    type: 'object',
                    properties: c.ControlData.Arguments,
                };
            }
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        schema: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
        navigateToModel: null,
        propertygrid: false,
    },
    render() {
        let desc;
        if (this.schema.description)
            desc = (
                <i
                    class="mdi mdi-information"
                    title={this.schema.description}
                    style={{ color: 'var(--v-checkboxGrey-base)', fontSize: 'small', marginLeft: '3px' }}
                ></i>
            );

        if (!this.cmodel.Arguments) this.cmodel.Arguments = {};

        const name = <span style={{ marginLeft: this.child * 15 + 'px' }}>{this.name}</span>;
        let form;
        if (this.control_schema) {
            form = (
                <PropertyGrid2
                    name="hsmStatement"
                    root={this.root}
                    schema={this.control_schema}
                    form={['*']}
                    cmodel={this.cmodel.Arguments}
                    child={0}
                    navigateToModel={this.root?.navigateToModel || this.navigateToModel}
                ></PropertyGrid2>
            );
        } else form = <TranslationContainer context={this} value={'Loading...'} />;

        return (
            <Pg2Row>
                {{
                    label: () => (
                        <span class="c-PropertyGrid2__labelInner">
                            {name} {desc}
                        </span>
                    ),
                    default: () => form,
                }}
            </Pg2Row>
        );
    },
});
